import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AnalyticsTotal} from 'app/features/analytics/features/monetization/interfaces/total';

@Component({
    selector: 'total-widget',
    templateUrl: './total-widget.component.html',
    styleUrls: ['./total-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TotalWidgetComponent implements OnChanges {
    @Input() totalItems: AnalyticsTotal[];
    @Input() spinnersCount: number;
    @Input() relatedDate: string;

    emptyTotals: {}[];

    createEmptyTotalsForSpinners(length: number): void {
        this.emptyTotals = Array.from({length}).fill({});
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.spinnersCount) {
            return;
        }

        this.createEmptyTotalsForSpinners(this.spinnersCount);
    }
}
